import { createSlice } from "@reduxjs/toolkit";
import { fetchBomList, fetchBomByItem, saveBom } from "./bomThunk";

const blankRow = () => ({
  key: Date.now() + Math.random(),
  item_id: null,
  product: "",
  quantity: 0,
  per_unit_id: null,
  unit_symbol: "",
});

const initialState = {
  bomList: [],
  bomId: null,
  finishedItemId: null,
  finishedItemName: "",
  narration: "",
  itemsCart: [blankRow()],
  isEdit: false,
  loading: false,
  success: null,
};

const bomSlice = createSlice({
  name: "bom",
  initialState,
  reducers: {
    resetBomForm() {
      return { ...initialState, itemsCart: [blankRow()] };
    },
    setFinishedItem(state, action) {
      const { item_id, product } = action.payload || {};
      state.finishedItemId = item_id;
      state.finishedItemName = product;
    },
    setNarration(state, action) {
      state.narration = action.payload;
    },
    addBomItemRow(state) {
      state.itemsCart.push(blankRow());
    },
    updateBomItemRow(state, action) {
      const { rowKey, updates } = action.payload;
      state.itemsCart = state.itemsCart.map((row) =>
        row.key === rowKey ? { ...row, ...updates } : row
      );
    },
    deleteBomItemRow(state, action) {
      state.itemsCart = state.itemsCart.filter((r) => r.key !== action.payload);
      if (state.itemsCart.length === 0) {
        state.itemsCart.push(blankRow());
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBomList.fulfilled, (state, action) => {
        state.bomList = action.payload || [];
      })
      .addCase(fetchBomByItem.fulfilled, (state, action) => {
        const { bom, items } = action.payload || {};
        if (!bom) {
          state.bomId = null;
          state.isEdit = false;
          state.itemsCart = [blankRow()];
          state.narration = "";
          return;
        }
        state.bomId = bom.bom_id;
        state.isEdit = true;
        state.finishedItemId = bom.item_id;
        state.narration = bom.narration || "";
        state.itemsCart =
          items && items.length > 0
            ? items.map((it) => ({
                key: it.bom_d_id,
                item_id: it.item_id,
                product: it.item_name,
                quantity: Number(it.quantity || 0),
                per_unit_id: it.per_unit_id,
                unit_symbol: "",
                average_rate: Number(it.average_rate || 0),
              }))
            : [blankRow()];
      })
      .addCase(saveBom.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveBom.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload;
      })
      .addCase(saveBom.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const {
  resetBomForm,
  setFinishedItem,
  setNarration,
  addBomItemRow,
  updateBomItemRow,
  deleteBomItemRow,
} = bomSlice.actions;

export default bomSlice.reducer;
